import styled from '@emotion/styled';

export const Breadcrumbs = styled.div`
  display: none;
  @media (min-width: 650px) {
    display: flex;
  }
`;
